import React from "react";
import Navbar from "../components/Navbar";
import HeroVenue from "../components/Hero_venue";
import Footer from "../components/Footer";
import headerImage from "../assets/header_image-01.png";
import PricingTable from "../components/costTable";
import Canonical from "../components/canonical";

export function Venue() {
  const heroAreaName = "Venues & Fees";

  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <HeroVenue heroAreaName={heroAreaName} imageSrc={headerImage} />
      <div className="bg-[#075AAA] text-[#ffffff]">
        <div className=" max-w-[1248px] w-full mx-auto flex flex-col">
          <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
            <h1>Venues and Fees</h1>
          </div>
          <div className="flex flex-wrap items-start pb-4 mx-6">
            <p className=" md:text-xl sm:text-lg text-sm my-4 ">
              We offer training sessions in different venues on different
              evenings, to cover different aspects of judo. Players who train
              more than once a week will progress faster, as with any sport.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-[#01184D] w-full mx-auto flex flex-col items-center justify-center text-white">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>TUESDAYS</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <h2 className="md:text-3xl text-lg sm:text-xl mx-6 my-4">
            Wick Hall, 76 Wick Street, Littlehampton BN17 7JS
          </h2>
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <span className="font-bold">
              JUNIORS from Ages 5 to 15 | 6.45-7.45
              <br />
              <br /> SENIORS 16 and over | 7.45-9.15
            </span>
            <br />
            <br />
            The sessions will normally be taken by 2 instructors and will focus
            on technique and application. The senior session can also provide
            training for kata, the formal demonstrations of judo. The club is
            currently only open in term times.
          </p>
        </div>
      </div>
      <div className="bg-[#C8102E] w-full mx-auto flex flex-col items-center justify-center text-[#ffffff]">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>Wednesdays</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <h2 className="md:text-3xl text-lg sm:text-xl mx-6 my-4">
            Ashington Community Centre, Foster Lane, Ashington RH20 3PG
          </h2>
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <span className="font-bold">
              SENIORS age 15 and over | 7:00 – 9.00
            </span>
            <br />
            The sessions will be taken by up to 3 instructors and include
            general training, throwing practice, and squad style contest work.
          </p>
        </div>
      </div>
      <div className="bg-[#ffffff] w-full mx-auto flex flex-col items-center justify-center text-[#01184D]">
        <div className="uppercase my-8 mx-4 md:text-4xl text-xl sm:text-2xl font-bold items-start text-center  ">
          <h1>Fridays</h1>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <h2 className="md:text-3xl text-lg sm:text-xl mx-6 my-4">
            The Main Hall, Worthing Leisure Centre, Shaftesbury Avenue, Worthing
            BN12 4ET
          </h2>
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <span className="font-bold">
              SENIORS and Juniors who are age 12 and over | 6.15 – 7.45
              <br />
              All new juniors aged 5 to 11 will start on Tuesdays
            </span>
            <br />
            This session will normally be taken by all instructors and will
            focus on techniques and several different applications, with the
            focus on experimental learning. We have several seniors in their 40s
            and 50s.
          </p>
        </div>
      </div>
      <div className="bg-[#075AAA] w-full mx-auto flex flex-col items-center justify-center text-[#ffffff]">
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <h2 className="font-bold ">MONTHLY TRAINING FEES</h2>
            <br />
            <span className=" underline">
              We will allow 3 free sessions for you to decide whether to
              continue your judo journey.
            </span>{" "}
            We will then ask you to set up a standing order. Please decide how
            many sessions per week are right for you to arrive at your standing
            order We are closed for up to 6 weeks of the year, summer and
            Christmas, but the payments continue across closed periods, so they
            are spread over 12 payments rather than 10.
            <br /> <br />
            <span className=" font-bold">
              Tuesdays: £5 per head paid on arrival <br />
              Wednesdays: £25 per month plus £20 for a second family member
              <br />
              Fridays: £25 per month plus £20 for a second family member <br />
              Fridays and Wednesdays: £45 per month plus £15 for a second family
              member
            </span>
            <br /> <br />
            <span className=" font-bold">Shift Work</span>
            <br />
            Some players have shift work or by nature of their work cannot
            commit to a weekly session and a standing order. In those cases we
            will accept <span className="font-bold">
              a prepay as you play
            </span>{" "}
            system as follows.{" "}
            <span className="font-bold">
              By 12 noon on the training day, in order to attend, you will
              transfer £7.50 per person by BACS to our bank account and email
              our Treasurer at{" "}
              <span className=" underline">
                <a href="mailto:paulkendall83@hotmail.co.uk">
                  paulkendall83@hotmail.co.uk
                </a>
              </span>{" "}
              confirming payment and attendance.
            </span>
            <br />
            <br />
            <span className=" font-bold">Split system</span>
            <br />
            Some players with changeable work times may be able to train{" "}
            <span className=" font-bold">EITHER</span> every Wednesday and
            occasional Fridays,
            <span className=" font-bold"> or </span>vice versa. In that case we
            will take a{" "}
            <span className=" font-bold">
              standing order for the regular day and a prepay as you play
              payment for the other day.
            </span>
          </p>
        </div>

        <h1 className="font-bold md:text-xl sm:text-lg text-sm mb-2">
          Payments - our bank details are: <br />
          BARCLAYS BANK
          <span className="font-normal">: RISING SUN JUDO CLUB</span>
          <br />
          SORT CODE
          <span className="font-normal">: 20-98-74</span>
          <br />
          ACCOUNT NUMBER
          <span className="font-normal">: 50552801</span>
          <br />
          REFERENCE
          <span className="font-normal">: THIS MUST CONTAIN YOUR NAME</span>
        </h1>

        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <h3 className="font-bold ">What other costs are involved?</h3>
            <br />
            You will need a judo licence which provides insurance cover. You
            will be given full details when you are ready to apply. The initial
            cost ranges from £31 to £46 and must be renewed each year. This
            should be done at the end of the first month. Judo has a system of
            coloured belts to denote your grade, which also denotes both your
            skill level and your knowledge. The grading fee in 2026 is up to
            £20, and your licence book{" "}
            <span classname=" underline">must be signed</span> at each grade.
            <br />
            <br />
            You will also need a judo suit, and we have a stock of these. We can
            advise you on size, and a training grade judo suit is around £30 to
            £45, depending on size. They must be washed regularly. We allow up
            to 4 weeks without these items.
          </p>
        </div>
        <div className="max-w-[1248px] flex flex-wrap gap-x-4 pb-4 ">
          <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
            <h3 className="font-bold">What is expected?</h3>
            <br />
            You should expect us to teach you a range of judo skills to a level
            that you want to reach, with individual help as well as learning in
            a group. We support both competitive and recreational players in
            equal measure.
            <br />
            From you, we expect regular attendance, attention when on the mat,
            good behaviour &amp; self-control. We also expect effort - you will
            only get out of your judo what you put into it. You’re here to learn
            how to defend yourself, take part in an active sport, and enjoy
            yourself too. You need a clean judo suit, and clean hands &amp;
            feet. <br />
            <br />
            <span className="font-bold">
              Put your shoes on if you leave the mat - no one wants the dirt
              from your feet on them.
            </span>
          </p>
        </div>
      </div>

      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
